import { render, staticRenderFns } from "./c-release.vue?vue&type=template&id=2e40e46a&scoped=true"
import script from "./c-release.vue?vue&type=script&lang=js"
export * from "./c-release.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40e46a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e40e46a')) {
      api.createRecord('2e40e46a', component.options)
    } else {
      api.reload('2e40e46a', component.options)
    }
    module.hot.accept("./c-release.vue?vue&type=template&id=2e40e46a&scoped=true", function () {
      api.rerender('2e40e46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/release/c-release.vue"
export default component.exports